import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Nav from './components/NavBar';
import Footer from './components/Footers';
import Home from './pages/Home';
import About from './pages/About';
import Advocate from './pages/AdvocateAtMeetings';
import TopBar from './components/TopBar';
import Heros from './components/Heros';

function App() {
  const location = useLocation();

  return (
    <div id='main'>
      <TopBar />
      <Nav />
      <Heros />

      <TransitionGroup>
        <CSSTransition
          key={location.pathname}
          classNames="fade"
          timeout={500}
        >
          <div id="main-content">
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/About" element={<About />} />
              <Route path="/Advocate" element={<Advocate />} />
            </Routes>
          </div>
        </CSSTransition>
      </TransitionGroup>

      <Footer />
    </div>
  );
}

export default App;
